import PigGroupMarketingBadge from './PigGroupMarketingBadge';

export default PigGroupMarketingBadge;
